export enum BID_STATUS_UUID {
	'9a0dc3e6-b451-4cf0-92e5-29d6e3695102' = 'Accepted',
	'88a8ba81-838a-43d3-86c5-d6d77240da71' = 'Cancelled',
	'd2261f74-2f48-4c01-a426-748ecb950912' = 'Countered',
	'4c64740b-40c1-4079-9650-93cdce09487c' = 'DAILY_LIMIT_REACHED',
	'269e4734-6ade-44a3-952b-6e619d0ac14b' = 'Declined',
	'a030ad02-2903-48f5-83ec-d74208d44c35' = 'Expired',
	'47102931-c5cd-4732-bb75-00e73c702e9e' = 'Invited',
	'225d67d1-a733-45f6-8425-a6973bc1c0ac' = 'New',
	'cb556a7e-8a46-4d08-850a-f2fa44e66673' = 'Viewed',
	'5903a778-52bc-42cc-8e66-5dab8a8821c4' = 'Selected',
	'f9559662-da71-11ec-9d64-0242ac120002' = 'Responded',
	'8914abf0-e508-4825-9c8c-4961db86dca5' = 'Scheduled',
	'160e5c86-5e14-4aee-b0c1-df2e3f59c24f' = 'Contacted',

	'RESPONSE_RECEIVED' = 'Responded',
}

export const BID_DISPLAY_STATUS_CONSTANTS = {
	NEW: 'New',
	INVITED: 'Invited',
	ACCEPTED: 'Accepted',
	DECLINED: 'Declined',
	COUNTER_SENT: 'Counter Sent',
	COUNTER_RECEIVED: 'Counter Received',
	VIEWED: 'Viewed',
	CANCELLED: 'Cancelled',
	CONFIRMED: 'Confirmed',
	DRAFT: 'Draft',
	SIGNED: 'Signed',
	EXPIRED: 'Expired',
	RATE_CON_SENT: 'RateCon Sent',
	SELECTED: 'Selected',
	RESPONSE_RECEIVED: 'Response Received',
	ASSIGNED: 'Assigned',
	SCHEDULED: 'Scheduled',
	DAILY_LIMIT_REACHED: 'Daily Limit Reached',
	CONTACTED: 'Contacted',
};

export enum BID_STATUS_STRING {
	'NEW' = 'NEW',
	'INVITED' = 'INVITED',
	'ACCEPTED' = 'ACCEPTED',
	'DECLINED' = 'DECLINED',
	'COUNTERED' = 'COUNTERED',
	'DRAFT' = 'DRAFT',
	'SIGNED' = 'SIGNED',
	'VIEWED' = 'VIEWED',
	'CANCELLED' = 'CANCELLED',
	'EXPIRED' = 'EXPIRED',
	'SELECTED' = 'SELECTED',
	'RESPONSE_RECEIVED' = 'RESPONSE_RECEIVED',
	'ASSIGNED' = 'ASSIGNED',
	'SCHEDULED' = 'SCHEDULED',
	'DAILY_LIMIT_REACHED' = 'DAILY_LIMIT_REACHED',
	'CONTACTED' = 'CONTACTED',
}

export enum BID_SOURCE_TYPE {
	'CARRIER' = 'CARRIER',
	'CUSTOMER' = 'CUSTOMER',
}
